/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DocumentoDto } from '../models/documento-dto';


/**
 * Documentos
 */
@Injectable({
  providedIn: 'root',
})
export class DocumentosService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getDocumento
   */
  static readonly GetDocumentoPath = '/documentos/{id}';

  /**
   * Obter documento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDocumento$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocumento$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<DocumentoDto>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentosService.GetDocumentoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DocumentoDto>;
      })
    );
  }

  /**
   * Obter documento.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDocumento$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocumento$Json(params: {
    id: number;
  }): Observable<DocumentoDto> {

    return this.getDocumento$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DocumentoDto>) => r.body as DocumentoDto)
    );
  }

  /**
   * Obter documento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDocumento$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocumento$Any$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentosService.GetDocumentoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Obter documento.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDocumento$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocumento$Any(params: {
    id: number;
  }): Observable<Blob> {

    return this.getDocumento$Any$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
